import { render } from "./UserEvents.vue?vue&type=template&id=542eed61"
import script from "./UserEvents.vue?vue&type=script&lang=js"
export * from "./UserEvents.vue?vue&type=script&lang=js"

import exportComponent from "/home/sam/kenban_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__